export const BASE_URL = "https://securpoint.app:4000/user/";
// export const BASE_URL = "http://89.116.21.92:7010/user/";

// Auth :
export const loginAPI = "login";
export const varifyOtpAPI = "verifyOtpMail";
export const forgotPasswordAPI = "forgetPassword";
export const varifyForgotOtpAPI = "verifyForgetPasswordOtp";
export const resetCurrentPasswordAPI = "createPassword";
export const resendOtpAPI = "resendOTP";
export const signUpAPI = "signupByEmail";
export const contactUsAPI = "contactUs";
export const subscriptionsAPI = "myPlans";
export const editProfileAPI = "editProfile";
export const profileAPI = "myProfile";
export const faqAPI = "faqs";
export const policyAPI = "getCms";
export const conditionsAPI = "getCms";

export const allAssetsAPI = "getMyAssets";
export const publicAssetsAPI = "publicHomePage";
export const homeAssetsAPI = "getAllAssets";
export const assetDetailAPI = "publicAsset/";
export const userDetailAPI = "getUser/";
